import { dateTimeUtil } from '@cmg/common';
import { createValueFormatter, getDateStringClientFilterProps } from '@cmg/data-grid';

import type { CalendarGridColDef, CalendarGridRowData } from '../../CalendarGrid.model';
import { dateStringColumnKeyCreator } from '../../CalendarGrid.model';

export type Value = CalendarGridRowData['publicFilingDate'];

export const valueFormatter = createValueFormatter<CalendarGridRowData, Value>({
  gridRow: ({ value }) => {
    return value ? dateTimeUtil.getDisplayValueForDate(value) : 'TBD';
  },
});

const { filterValueGetter, ...filterProps } =
  getDateStringClientFilterProps<CalendarGridRowData>('publicFilingDate');

export { filterValueGetter };

const filingDateColDef: CalendarGridColDef<Value> = {
  field: 'publicFilingDate',
  headerName: 'Filing Date',
  width: 135,
  type: 'date',
  enableRowGroup: true,
  valueFormatter,
  keyCreator: dateStringColumnKeyCreator<Value>,
  filterValueGetter,
  ...filterProps,
};

export default filingDateColDef;
